import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilterOption } from '../../loop-v2-filters.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { map, startWith, take } from 'rxjs/operators';

interface DialogData {
  selected: FilterOption;
  options: Observable<FilterOption[]>;
  title: string;
  placeholder: string;
}

@Component({
  selector: 'sales-common-single-selection-dialog',
  templateUrl: './single-selection-dialog.component.html',
  styleUrls: ['./single-selection-dialog.component.scss'],
})
export class SingleSelectionDialogComponent implements OnInit {
  formControl = new UntypedFormControl();
  options$: Observable<FilterOption[]>;
  filteredOptions$: Observable<FilterOption[]>;

  selectedOption: FilterOption;

  constructor(
    public dialogRef: MatDialogRef<SingleSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.formControl.setValue(this.data.selected?.name);

    this.options$ = this.data.options;
  }

  ngOnInit(): void {
    this.filteredOptions$ = combineLatest([this.formControl.valueChanges.pipe(startWith('')), this.options$]).pipe(
      map(([value, options]) => this._filter(value, options)),
    );
  }

  private _filter(value: string, options: FilterOption[]): FilterOption[] {
    const filterValue = value.toLowerCase();

    return options.filter((option) => option.name.toLowerCase().includes(filterValue));
  }

  close(newData: boolean): void {
    if (!newData) {
      this.dialogRef.close();
      return;
    }
    this.dialogRef.close(this.selectedOption);
  }

  setOption(event: MatAutocompleteSelectedEvent): void {
    // Find the selected option
    this.options$
      .pipe(
        take(1),
        map((options) => {
          for (const option of options) {
            if (option.name === event.option.value) {
              return option;
            }
          }
        }),
      )
      .subscribe((option) => {
        this.selectedOption = option;
      });
  }
}
